export type MessageReceiptState = 'sent' | 'delivered' | 'read';

export const getMessageReceiptState = (
  message: { sender: string; deliveredAt?: string | null; readAt?: string | null },
  userId: string
): MessageReceiptState | null => {
  if (message.sender !== userId) {
    return null;
  }

  if (message.readAt) {
    return 'read';
  }

  if (message.deliveredAt) {
    return 'delivered';
  }

  return 'sent';
};
